import Vue from 'vue'
import Vuetify from 'vuetify'
import tema from './theme'
import pt from 'vuetify/es5/locale/pt'
//import colors from 'vuetify/es5/util/colors'
import colors from 'vuetify/lib/util/colors'
import 'vuetify/dist/vuetify.min.css'
//import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

//console.log(tema)

const dark = tema.light
const light = tema.light
const green = tema.green

const opts = {
  iconfont: 'mdi',
  /*lang: {
    locale: { pt },
    current: 'pt',
  },*/
  lang: {
    locales: { pt },
    current: 'pt',
  },
  theme: {
    dark: false,
    themes: {
      /*dark: {
        primary: colors.teal.darken1,
        accent: colors.indigo.darken1,
        info: colors.blue,
        error: colors.pink.darken2,
        success: colors.teal.lighten1,
        warning: colors.purple.darken1,
      },*/
      dark,
      light,
      green
    },
  /*themes: {
    themes: { light } 
    }*/
    
  }
}

export default new Vuetify(opts)


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js